import { CreateControllerFn } from '@wix/yoshi-flow-editor';

import { RequestStatus } from '../../utils/wrapRequest';
import { noop } from '../../utils/noop';
import { DEFAULT_LOCALE } from '../../utils/constants';
import { DispatchType } from '../../types/businessTypes';
import type { OnlineOrdersStorage } from '../../components/OnlineOrders/storage';

import { getMockMenus, getMockOperation, getMockItemMap } from './menus';
import {
  getMockFulfillmentMethods,
  getMockDispatchesInfo,
} from './getFulfillmentMethodMocks';

export const getDefaultMockOnlineOrdersStorage = (): OnlineOrdersStorage => {
  const mockOperation = getMockOperation();

  return {
    siteLocale: DEFAULT_LOCALE,
    timezone: 'America/New_York',
    isPremium: false,
    fetchIsPremiumStatus: RequestStatus.RESOLVED,
    fitToContentHeight: true,
    operations: [mockOperation],
    currentOperation: mockOperation,
    isLocationSelected: true,
    menus: getMockMenus(),
    menuAvailabilityById: {},
    menuAvailabilityStatusById: {},
    menuNextAvailabilityById: {},
    sectionAvailabilityById: {},
    sectionAvailabilityStatusById: {},
    itemMap: getMockItemMap(),
    cartQuantities: {},
    discountRules: [],
    connectedDiscountInfoByItemId: {},
    fetchDiscountRulesStatus: RequestStatus.RESOLVED,
    fetchOperationsStatus: RequestStatus.RESOLVED,
    fetchMenusStatus: RequestStatus.RESOLVED,
    fetchItemsStatus: RequestStatus.RESOLVED,
    fulfillmentMethods: getMockFulfillmentMethods(),
    fetchFulfillmentMethodsStatus: RequestStatus.RESOLVED,
    selectedDispatchType: DispatchType.PICKUP,
    currency: 'USD',
    timeSlots: [],
    fetchTimeSlotsStatus: RequestStatus.RESOLVED,
    timeSlotsByOperationId: {},
    fetchTimeSlotsByOperationStatus: RequestStatus.RESOLVED,
    acceptingDispatchTypesByOperationId: {},
    dispatchesInfo: getMockDispatchesInfo(),
    hasError: false,
    coverImage: {
      id: 'f35a26_6cc328fb763841249ba03010e0f678f5~mv2.jpg',
      url: 'https://static.wixstatic.com/media/f35a26_6cc328fb763841249ba03010e0f678f5~mv2.jpg',
      width: 2035,
      height: 1054,
    },
    fetchCoverImageStatus: RequestStatus.RESOLVED,
    fetchOperations: noop,
    fetchMenus: noop,
    getCachedOperationMenus: () => getMockMenus(),
    updateMenuAvailabilityStatus: () => Promise.resolve([]),
    fetchItems: noop,
    fetchDiscountRules: noop,
    fetchFulfillmentMethods: noop,
    fetchTimeSlots: noop,
    fetchTimeSlotsByOperation: noop,
    fetchIsPremium: () => Promise.resolve(false),
    fetchCoverImage: noop,
    setIsLocationSelected: noop,
    setSelectedDispatchType: noop,
    setDispatchesInfo: noop,
    setAcceptingDispatchTypesByOperationId: noop,
    onItemClick: noop,
    openCart: noop,
    openFulfillmentModal: noop,
    reportMenuBarClick: noop,
    reportMenuDropdownClick: noop,
    reportMenuStatusCardDisplayed: noop,
  };
};

export const createMockOnlineOrdersController =
  (overrides: Partial<OnlineOrdersStorage> = {}): CreateControllerFn =>
  async ({ flowAPI }) => ({
    async pageReady() {
      flowAPI.controllerConfig.setProps({
        ...getDefaultMockOnlineOrdersStorage(),
        ...overrides,
      });
    },
  });
